export const writeReviews = {
    mySummary: {
        title: "내가 들은 과목",
        written: "작성 후기",
        likes: "추천",
        selectPlaceholder: "강의를 선택해주세요",
    },
    write: {
        title: "후기 작성 - {{lectureName}}",
        related: "연관 후기 - {{lectureName}}",
        edit: "수정하기",
    },
    hallOfFameFeed: {
        title: "명예의 전당 - {{year}}<space/>{{semester}}",
        total: "전체 후기",
    },
    likedReviews: {
        title: "좋아요한 후기",
    },
    tabs: {
        write: "후기 작성하기",
        recentFeed: "따끈따끈 후기",
        hallOfFameFeed: "명예의 전당",
        liked: "좋아요한 후기",
    },
}
